var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-card-haines-gallery-card",class:_vm.rootClassName},[_c('img',{staticClass:"gallery-card-haines-image button",attrs:{"alt":_vm.image_alt,"src":_vm.image_src,"loading":"eager"}}),_c('h2',{staticClass:"gallery-card-haines-text"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }